export enum IFlowTabs {
  addNewFlow = "1",
  flowTable = "2",
}
